module.exports = __webpack_public_path__ + "8082b002cb90c7f3754fb215688eedae.png";